module.exports = __webpack_public_path__ + "img/Group87 (1).3331bb62.svg";